
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".8","width":"20.8","height":"16","rx":"3","fill":"#fff"}}),_c('path',{attrs:{"d":"M8.545 11.007c1.395 0 2.27-.818 2.339-2.022h-1.37c-.086.56-.454.873-.952.873-.678 0-1.118-.57-1.118-1.572 0-.988.443-1.554 1.118-1.554.532 0 .873.35.951.872h1.37c-.06-1.21-.977-2.004-2.345-2.004-1.588 0-2.57 1.101-2.57 2.707 0 1.592.965 2.7 2.577 2.7zM14.18 11.007c1.394 0 2.27-.818 2.338-2.022h-1.37c-.085.56-.454.873-.951.873-.679 0-1.118-.57-1.118-1.572 0-.988.443-1.554 1.118-1.554.532 0 .872.35.95.872h1.371c-.061-1.21-.978-2.004-2.345-2.004-1.589 0-2.57 1.101-2.57 2.707 0 1.592.964 2.7 2.577 2.7z","fill":"#000"}})])
          )
        }
      }
    